<div class="button" (click)="toggleIcon = !toggleIcon">
  <span> {{ label }}</span>
  <i [ngClass]="toggleIcon ? 'pi pi-angle-up' : 'pi pi-angle-down'"></i>
</div>
